<template lang="pug">

	div
		div(v-if="!memberCreated")
			div.mb-3
				p.text-muted.my-1 Добавьте участника в группу без создания аккаунта
				b-alert(variant="warning" show) Обратите внимание! Созданный без регистрации участник группы не будет получать уведомлений от организаторов и не сможет добавить аннотацию своего доклада, если это требуется

			formCreateMember(v-if="!memberCreated" :_cbOK="createMemberCbOK")

		div(v-else)
			div
				div.my-2 Вы только что создали участника

				// div.d-flex.align-items-center
					img(src="/img/placeholders/avatar.png" width="50" style="border-radius:50%;")
					div.ml-2
						div {{ members.post.data.first_name }} {{ members.post.data.last_name }}

				div.my-2 Хотите добавить его в группу?

			div
				b-alert.mt-3(v-if="_event.extra_data.length" show variant="warning") Чтобы добавить пользователя в группу выберите параметры его участия в форме ниже
				FormPpnt( :_event="_event" :_msgOK="'Участник успешно добавлен в группу!'" :_cbOK="createPpntCbOK" :_htmlFormModel="_event.use_price ? regFormModel : []" :_memberID="page.participant.regMemberID" :_ppntID="myParticipant.data.id" :_submitText="'Добавить в группу'")

</template>
<script>
	import { mapState } from 'vuex';

	import formCreateMember from '../forms/formCreateMember'
	import FormPpnt from '../../../components/FormPpnt'


	let regFormModel = [
		{ name:"promo_code", placeholder:"Промокод", type:"text" },
	];
	export default {
		name: 'createMemberTab',
		props: ['_ppnt', '_cbOK', '_event'],
		components: {
			formCreateMember,
			FormPpnt,
		},
		data: () => ({
			regFormModel,
			memberCreated: false
		}),
		computed: {
			...mapState(['page','myParticipant','members']),
		},
		methods:{
			createPpntCbOK(){
				this.$store.dispatch('getMyParticipant', { id:this.myParticipant.data.id });
				setTimeout(()=>{
					this.$bvModal.hide('addExtraParticipantModal');
					this.$store.commit('clearMembersPost');
					this.memberCreated = false;
				}, 1000);
			},
			createMemberCbOK(){
				this.$store.commit('setRegMemberID', this.members.post.data.dependent_member);
				setTimeout(()=> {
					this.memberCreated = true;
				}, 1000);
			},
		}
	}
</script>

